/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios';

import { loginApi } from '../../setup/setupApi';
import { merchantApi } from '../../setup/setupMerchantApi';
import {
  EmailCustomization,
  OldLoginWidgetParamsType,
  OldLoginWidgetStyleType,
  SmsCustomization,
  UploadFileType
} from './types';

export const getEmailCustomization = (projectId: string): Promise<EmailCustomization> =>
  loginApi.get(`projects/${projectId}/email_notification`).then((res) => res.data);

export const putEmailCustomization = (
  projectId: string,
  customization: EmailCustomization
): Promise<EmailCustomization> =>
  loginApi.put(`projects/${projectId}/email_notification`, customization).then((res) => res.data);

export const getOldLoginWidgetParams = (): Promise<OldLoginWidgetParamsType> =>
  loginApi
    .get('widget/params', {
      headers: { Authorization: 'undefined' }
    })
    .then((res) => res.data);

export const getOldLoginWidgetRequest = (projectId: string): Promise<OldLoginWidgetStyleType> =>
  loginApi.get(`projects/${projectId}/widget_style`).then((res) => res.data);

export const putOldLoginWidgetRequest = (
  projectId: string,
  custom_css: string,
  versionState: null | string
): Promise<OldLoginWidgetStyleType> =>
  loginApi.put(`projects/${projectId}/widget_style`, {
    update_version: versionState === 'updating',
    custom_css: custom_css || null
  });

export const uploadMerchantFile = (
  merchantId: number,
  formData: FormData
): Promise<UploadFileType> =>
  merchantApi
    .post<FormData, AxiosResponse<UploadFileType>>(
      `/merchant/current/merchants/${merchantId}/files`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
    )
    .then((res) => res.data);

export const getSmsCustomization = (projectId: string): Promise<SmsCustomization> =>
  loginApi.get(`/projects/${projectId}/templates/sms`).then((res) => res.data);

export const putSmsCustomization = (
  projectId: string,
  templates: SmsCustomization
): Promise<SmsCustomization> =>
  loginApi.put(`/projects/${projectId}/templates/sms`, templates).then((res) => res.data);

export const getCustomStyleURL = (projectId: string): Promise<{ custom_style_url: string }> =>
  loginApi.get(`/projects/${projectId}/custom_style_url`).then((res) => res.data);

export const postCustomStyleURL = (projectId: string, customStyleUrl: string) =>
  loginApi.post(`/projects/${projectId}/custom_style_url`, { custom_style_url: customStyleUrl });
